module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_red.69a2a53d.svg";